import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Register service worker at startup for push notifications
import "./lib/serviceWorkerRegistration";

createRoot(document.getElementById("root")!).render(<App />);
